import LBoxedList from "../lboxed-list/LBoxedList";
import WButton from "../wbutton/WButton";
import { useRouter } from "next/router";
import { motion } from "framer-motion";
import parse from "html-react-parser";
import LCountDownTimer from "../lcount-down-timer/LCountDownTimer";
import fbEvent from "@/utils/fbEvent";

/* eslint-disable-next-line */
export interface LScrollableListSectionProps {
  id?: string;
  backgroundImageUrl?: string;
  topTitle?: string;
  mainTitle: string;
  secondaryTitle?: string;
  boxes: {
    boxTitle: string;
    boxText: string; // rich text
    listTitle?: string;
    bottomText?: string;
    boxCards?: {
      title: string;
      imgUrl?: string;
      altTag?: string;
      text?: string;
      showMoreText?: string; //rich text
    }[];
  }[];
  bottomSectionImgUrl?: string;
  bottomSectionTitle?: string;
  button?: {
    text: string;
    url: string;
  };
  countDownTimer?: {
    endDate: Date;
    description?: string;
  };
}

export function LScrollableListSection(props: LScrollableListSectionProps) {
  const router = useRouter();
  return (
    <div
      id={props?.id}
      style={{
        backgroundImage: `url('${props?.backgroundImageUrl}')`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right center",
        backgroundSize: "80vh",
        backgroundAttachment: "fixed",
      }}
      className="relative py-20 no-mob-bg"
    >
      <div className="container flex gap-10 px-4 mx-auto lg:max-w-7xl">
        <div className="space-y-10 lg:w-1/2 lg:pr-10">
          <img src={props?.backgroundImageUrl} alt="" className="xl:hidden" />
          <div className="space-y-5">
            {props?.topTitle && (
              <div className="-mb-5 text-xl font-semibold text-ekgreen">
                {props?.topTitle}
              </div>
            )}

            <h1>{parse(props?.mainTitle)}</h1>
            {props?.secondaryTitle && <p>{props?.secondaryTitle}</p>}
          </div>
          {props?.boxes?.map((box, idx) => (
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false }}
              transition={{ duration: 1, type: "spring", delay: 0.3 }}
              key={idx}
            >
              <LBoxedList
                boxTitle={box?.boxTitle}
                boxText={box?.boxText}
                listTitle={box?.listTitle}
                bottomText={box?.bottomText}
                boxCards={box?.boxCards?.map((boxCard) => ({
                  title: boxCard?.title,
                  imgUrl: boxCard?.imgUrl,
                  altTag: boxCard?.altTag,
                  text: boxCard?.text,
                  showMoreText: boxCard?.showMoreText,
                }))}
              />
            </motion.div>
          ))}
          <div className="flex flex-col items-center gap-10 text-center">
            {props?.bottomSectionImgUrl && (
              <div>
                <img src={props?.bottomSectionImgUrl} alt="" />
              </div>
            )}
            {props?.bottomSectionTitle && <h2>{props?.bottomSectionTitle}</h2>}

            {props?.button?.text && props?.button?.url && (
              <WButton
                text={props?.button?.text}
                type="primary-red-btn"
                className="mx-auto w-fit lg:mx-0"
                onClick={() => {
                  props?.button?.url && router.push(props?.button.url);
                  fbEvent("Schedule");
                }}
              />
            )}

            {props?.countDownTimer && (
              <div>
                <LCountDownTimer
                  endDate={new Date(props?.countDownTimer?.endDate)}
                  description={props?.countDownTimer?.description}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LScrollableListSection;
